/* import { StorageSyncType, WindowRef } from '@spartacus/core';

export function getStorage(
  storageType: StorageSyncType,
  winRef: WindowRef
): Storage | undefined {
  let storage: Storage | undefined;

  switch (storageType) {
    case StorageSyncType.LOCAL_STORAGE: {
      storage = winRef.localStorage;
      break;
    }
    case StorageSyncType.SESSION_STORAGE: {
      storage = winRef.sessionStorage;
      break;
    }
    case StorageSyncType.NO_STORAGE: {
      storage = undefined;
      break;
    }

    default: {
      storage = winRef.sessionStorage;
    }
  }

  return storage;
}

export function persistToStorage(
  configKey: string,
  value: any,
  storage: Storage
): void {
  if (!isSsr(storage) && value) {
    storage.setItem(configKey, JSON.stringify(value));
  }
}

export function readFromStorage(storage: Storage, key: string): unknown {
  if (isSsr(storage)) {
    return null;
  }

  const storageValue = storage.getItem(key);
  if (!storageValue) {
    return null;
  }

  return JSON.parse(storageValue);
}

export function isSsr(storage: Storage): boolean {
  return !Boolean(storage);
}
 */
import { StorageSyncType, WindowRef } from '@spartacus/core';


export type StorageType = Storage | undefined;

/**
 * Safely get the requested storage. Returns `undefined` on SSR.
 */
export function getStorage(
  storageType: StorageSyncType,
  winRef: WindowRef
): StorageType {
  if (!winRef.isBrowser()) {
    return undefined;
  }

  try {
    switch (storageType) {
      case StorageSyncType.LOCAL_STORAGE:
        return winRef.nativeWindow?.localStorage;
      case StorageSyncType.SESSION_STORAGE:
        return winRef.nativeWindow?.sessionStorage;
      default:
        return undefined;
    }
  } catch {
    return undefined;
  }
}

/**
 * Safely write to storage.
 */
export function persistToStorage(
  key: string,
  value: any,
  storage?: Storage
): void {
  if (!storage) {
    return;
  }
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore write errors (quota exceeded, private mode, etc.)
  }
}

/**
 * Safely read from storage.
 */
export function readFromStorage<T = any>(
  storage: Storage,
  key: string
): T | undefined {
  if (!storage) {
    return undefined;
  }
  try {
    const raw = storage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : undefined;
  } catch {
    return undefined;
  }
}
